"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var PasswordStrength = function PasswordStrength(_ref) {
  var score = _ref.score,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["score", "className"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('flex items-center px-4 mb-2 py-1', {
      'w-1/3 bg-red': score < 2,
      'w-2/3 bg-orange': score > 1 && score < 4,
      'w-full bg-green': score > 3
    }, className),
    style: {
      transition: 'all .2s ease'
    }
  }, rest), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-xs text-white font-bold leading-none capitalize"
  }, score < 2 ? 'weak' : score < 4 ? 'fair' : 'strong'));
};

var _default = PasswordStrength;
exports["default"] = _default;
//# sourceMappingURL=index.js.map